import {Dispatch} from 'redux';
import {ErrorDto} from '../../../models/dtos/error.dto';
import {QuestionDto} from '../../../models/dtos/question.dto';
import {Errors} from '../../../utilities/errors';
import {
  GET_CURRENT_QUESTION_FAIL,
  GET_CURRENT_QUESTION_RESET,
  GET_CURRENT_QUESTION_START,
  GET_CURRENT_QUESTION_SUCCESS
} from './constants';
import {getCurrentQuestionRequest} from "./repository";
import {
  GetCurrentQuestionFailAction,
  GetCurrentQuestionResetAction,
  GetCurrentQuestionStartAction,
  GetCurrentQuestionSuccessAction
} from './types';

const getCurrentQuestionStartAction = (): GetCurrentQuestionStartAction => {
  return {
    type: GET_CURRENT_QUESTION_START,
  };
};
const getCurrentQuestionSuccessAction = (payload: QuestionDto): GetCurrentQuestionSuccessAction => {
  return {
    type: GET_CURRENT_QUESTION_SUCCESS,
    payload: payload,
  };
};
const getCurrentQuestionFailAction = (error: ErrorDto): GetCurrentQuestionFailAction => {
  return {
    type: GET_CURRENT_QUESTION_FAIL,
    error: error,
  };
};
const getCurrentQuestionResetAction = (): GetCurrentQuestionResetAction => {
  return {
    type: GET_CURRENT_QUESTION_RESET,
  };
};

export const getCurrentQuestion = () => async (dispatch: Dispatch) => {
  try {
    dispatch(getCurrentQuestionStartAction());
    const response = await getCurrentQuestionRequest();
    dispatch(getCurrentQuestionSuccessAction(response));
  } catch (error) {
    dispatch(getCurrentQuestionFailAction(Errors.getErrorDtoFromApiError(error)));
  }
};

export const getCurrentQuestionReset = () => (dispatch: Dispatch) => {
  dispatch(getCurrentQuestionResetAction());
};
